import { Link } from "react-router-dom";
import { Plane, Hotel, Briefcase, Ship, Shield, FileText } from "lucide-react";
import SectionHeader from "@/components/layout/SectionHeader";

const CATS = [
  { to: "/flights", icon: Plane, label: "Flights", color: "bg-brand-50 text-brand", desc: "Compare 600+ airlines" },
  { to: "/hotels", icon: Hotel, label: "Hotels", color: "bg-accent-50 text-accent-600", desc: "1M+ properties worldwide" },
  { to: "/packages", icon: Briefcase, label: "Packages", color: "bg-brand-50 text-brand", desc: "Curated holiday bundles" },
  { to: "/deals?cat=cruises", icon: Ship, label: "Cruises", color: "bg-accent-50 text-accent-600", desc: "Luxury sailings" },
  { to: "/deals?cat=insurance", icon: Shield, label: "Travel Insurance", color: "bg-brand-50 text-brand", desc: "Trip protection" },
  { to: "/visa-guides", icon: FileText, label: "Visa Services", color: "bg-accent-50 text-accent-600", desc: "Step-by-step guides" },
];

export default function TravelCategories() {
  return (
    <section data-testid="travel-categories" className="bg-slate-50 py-16 md:py-24 border-y border-slate-200">
      <div className="container-page">
        <SectionHeader
          align="center"
          kicker="What we cover"
          title="Everything for your trip in one place"
          subtitle="Plan, compare and book all parts of your journey — from flights to insurance — with trusted affiliate partners."
        />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {CATS.map((c) => (
            <Link
              key={c.label}
              to={c.to}
              data-testid={`category-${c.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="group bg-white rounded-2xl border border-slate-200 p-5 text-left card-hover"
            >
              <div className={`inline-flex w-12 h-12 items-center justify-center rounded-xl ${c.color} mb-3`}>
                <c.icon size={22} />
              </div>
              <div className="font-montserrat font-bold text-slate-900">{c.label}</div>
              <div className="text-xs text-slate-500 mt-0.5">{c.desc}</div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
